import { ContentResponse, getItemDisplayTitle, ContentType } from "@authory-packages/core";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";
import { getThumbnaiPlaceholderIcon } from "../ContentList/ContentList.utils";
import { VerticalSpacing } from "../VerticalSpacing";
import {
    V3DashboardListItem,
    V3DashboardListItemImageContainer,
    V3DashboardListItemImageImage,
    V3DashboardListItemImageImageShimmer,
    V3DashboardListItemTitle
} from "./V3ItemPreview.styles";
import { CLPlaceholderWrapper } from "../ItemImage/ItemImage.styles";
import { ItemMetadata } from "../ItemMetadata";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";

export type ItemPreviewResponse = Pick<
    ContentResponse,
    "slug" | "thumbnailImage" | "type" | "date" | "sourceName" | "originalUrl" | "title" | "ogTitle" | "description" | "ogDescription" | "source"
>;

interface V3ItemPreviewProps {
    item: ItemPreviewResponse;
    isBusinessParent?: boolean;
    optionalQueryParams?: string;
    target?: string;
    skipMetadata?: boolean;
    skipUrl?: boolean;
    imageShimmerEnabled?: boolean;
}

export const V3ItemPreview = ({
    item,
    isBusinessParent = false,
    optionalQueryParams = "",
    target,
    skipMetadata = false,
    imageShimmerEnabled = false,
    skipUrl = false
}: V3ItemPreviewProps) => {
    const url = `${APPLICATION_ROUTES.CONTENT}/${item.slug}${optionalQueryParams}`;

    return (
        <UnstyledLink href={!skipUrl ? url || undefined : undefined} target={target} skipCursor={skipUrl}>
            <V3DashboardListItem $shimmerEnabled={false}>
                {item && (
                    <>
                        <V3DashboardListItemImageContainer>
                            {imageShimmerEnabled ? (
                                <V3DashboardListItemImageImageShimmer $shimmerEnabled />
                            ) : (
                                <>
                                    <V3DashboardListItemImageImage src={item?.thumbnailImage || undefined} />
                                    {!item.thumbnailImage && (
                                        <CLPlaceholderWrapper>
                                            {getThumbnaiPlaceholderIcon("type" in item ? item.type : ContentType.Article)}
                                        </CLPlaceholderWrapper>
                                    )}
                                </>
                            )}
                        </V3DashboardListItemImageContainer>
                        <div>
                            <V3DashboardListItemTitle as="div">{getItemDisplayTitle(item)}</V3DashboardListItemTitle>
                            <VerticalSpacing top={skipMetadata ? 24 : 6}>
                                {!skipMetadata && (
                                    <ItemMetadata item={item} hideFavicon showRedirect={false} isB2B={isBusinessParent} hideUserAvatar />
                                )}
                            </VerticalSpacing>
                        </div>
                    </>
                )}
            </V3DashboardListItem>
        </UnstyledLink>
    );
};
